import styled from "styled-components";
import { FaDiscord, FaTwitter } from "react-icons/fa";
import { BsGlobe } from "react-icons/bs";

export const MainFooter = styled.div``;

export const UpperContainer = styled.div`
  background-color: #e67e22;

  .container {
    min-height: 15vh;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 767.98px) {
      flex-direction: column;
    }
  }
`;

export const LeftSide = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 60px;

  @media (max-width: 575.98px) {
    gap: 30px;
  }
`;

export const RightSide = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
`;

export const FooterLink = styled.h4`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: #ffffff;
  cursor: pointer;
`;

export const Discord = styled(FaDiscord)`
  color: #ffffff;
  font-size: 25px;
  cursor: pointer;
  transition: 0.2s all;

  &:hover {
    scale: 1.2;
  }
`;

export const Twitter = styled(FaTwitter)`
  color: #ffffff;
  font-size: 25px;
  cursor: pointer;
  transition: 0.2s all;

  &:hover {
    scale: 1.2;
  }
`;

export const Globe = styled(BsGlobe)`
  color: #ffffff;
  font-size: 25px;
  cursor: pointer;
  transition: 0.2s all;

  &:hover {
    scale: 1.2;
  }
`;

export const BottomContainer = styled.div`
  padding: 0px 80px;
  overflow: hidden;

  @media (max-width: 1399.98px) {
    padding: 0px 0px;
  }

  .container {
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 767.98px) {
      flex-direction: column;
    }
  }
`;

export const BottomLeftContainer = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */
  color: #000000;
  margin-top: 20px;
  margin-bottom: 20px;
  flex-grow: 1;

  @media (max-width: 575.98px) {
    text-align: center;
    line-height: 30px;
    margin-bottom: 0px;
  }
`;

export const BottomRightContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 40px;
  flex-grow: 1;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const BottomLinks = styled.p`
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
  margin-bottom: 0;
  cursor: pointer;
`;

// Admin Footer

export const Ul = styled.ul`
  list-style: none;
  color: white;
`;
export const Li = styled.li`
  font-size: 12px;
  font-weight: 500;
  margin-top: 0.8rem;
  list-style: none;
  color: white;
`;

export const MainUl = styled.p`
  display: flex;
  justify-content: end;
  gap: 0.5rem;
`;
export const CopyrighText = styled.p`
  color: white;
  margin-left: 2rem;
  font-weight: 600;
`;
